// extracted by mini-css-extract-plugin
export var item = "mentors-item-module--item--5-kPU";
export var imageWrapper = "mentors-item-module--image-wrapper--NqgL7";
export var imageWrapperTrackOwner = "mentors-item-module--image-wrapper-track-owner--tL9Pg";
export var image = "mentors-item-module--image--HMw2E";
export var label = "mentors-item-module--label--TgY6I";
export var title = "mentors-item-module--title--quq-o";